import { IAuth } from "@base/modules/auth/auth.interface";
import { ResponseHomeModule } from "@base/modules/homeModules/interfaces/IHomeModule.interface";
import { IUserInfo } from "@base/modules/user/account/account.interface";
import { NotificationType } from "@base/types";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface IAlertMessage {
  type?: NotificationType;
  message?: React.ReactNode | React.ReactNode[];
  description?: React.ReactNode | React.ReactNode[];
}

interface IAppCommonState {
  auth?: IAuth;
  stringeeToken?: string;
  userInfo?: IUserInfo;
  alertMessage: IAlertMessage;
  dataCommon?: ResponseHomeModule;
}

const initialState: IAppCommonState = {
  auth: undefined,
  stringeeToken: undefined,
  userInfo: undefined,
  alertMessage: {},
  dataCommon: undefined,
};

export const appCommonSlice = createSlice({
  name: "app-common-state",
  initialState,
  reducers: {
    setAuth: (state, action: PayloadAction<IAuth | undefined>) => {
      state.auth = action.payload;
    },
    setStringeeToken: (state, action: PayloadAction<string | undefined>) => {
      state.stringeeToken = action.payload;
    },
    setUserInfo: (state, action: PayloadAction<IUserInfo | undefined>) => {
      state.userInfo = action.payload;
    },
    setAlertMessage: (state, action: PayloadAction<IAlertMessage>) => {
      state.alertMessage = action.payload;
    },
    setDataCommon: (state, action: PayloadAction<ResponseHomeModule>) => {
      state.dataCommon = action.payload;
    },
  },
});

export const { setAuth, setStringeeToken, setUserInfo, setAlertMessage, setDataCommon } = appCommonSlice.actions;

export default appCommonSlice.reducer;
